<template>
  <el-dialog title="台班详情" :visible.sync="dialogVisible" width="1188" :before-close="handleClose">
    <el-form ref="formData" class="global-form3" :model="info" label-position="right" label-width="110px">
      <div class="flex">
        <el-form-item label="所属项目" prop="projectId">
          <el-select disabled v-model="info.projectId" filterable placeholder="请选择所属项目">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="machineTeamDate" label="台班日期">
          <el-date-picker disabled v-model="info.machineTeamDate" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择台班日期">
          </el-date-picker>
        </el-form-item>
      </div>

      <el-form-item class="mb20" label="台班机械" prop="machineTeamLines">
      </el-form-item>

      <div class="table">
        <el-table class="global-table global-tables mb30 my-table" max-height="400" :data="info.machineTeamLines"
          :summary-method="getSummaries" show-summary border ref="table">
          <el-table-column label="机械名称" prop="machineryName" align='center'>
          </el-table-column>
          <el-table-column label="规格型号" prop="specificationModel" align='center' showOverflowTooltip>
          </el-table-column>
          <el-table-column label="供应商名称" prop="supplierId" align='center' showOverflowTooltip>
            <template v-slot="{ row }">
              <div style="overflow: hidden;">{{ row.supplierName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="是否含油" align='center'>
            <template v-slot="{ row }">
              <div>{{ row.whetherOil === '1' ? '是' : '否' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="作业内容" prop="jobContent" align='center' showOverflowTooltip>
          </el-table-column>
          <el-table-column label="台班/小时数" prop="hours" align='center' showOverflowTooltip>
          </el-table-column>
          <!-- <el-table-column label="单价(元)" prop="price" align='center' showOverflowTooltip>
            </el-table-column> -->
          <el-table-column label="台班金额" prop="teamPrice" align='center' showOverflowTooltip>
          </el-table-column>
          <el-table-column label="备注" prop="lineRemark" align='center' showOverflowTooltip>
          </el-table-column>
        </el-table>
      </div>
      <el-form-item prop="headRemark" label="备注信息">
        <el-input v-if="info?.headRemark?.length" v-model="info.headRemark" placeholder="请输入备注信息" type="textarea"
          disabled show-word-limit :rows="3" maxlength="200" />
        <div v-else>--</div>
      </el-form-item>
      <el-form-item label="现场图片" prop="fileList">
        <div class="imgList">
          <div class="imgBlock" v-for="(item, index) in info.fileList" :key="index">
            <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="info.fileList | imgListFormat"
              fit="fill">
            </el-image>
          </div>
        </div>
        <div class="mt20">(最多六张)</div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'AddTaiBanLabor',
  props: {
    id: {
      type: String,
      default: ''
    },
    detailsShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      info: {
        // 基础信息
        projectId: '',
        machineTeamDate: '',
        machineTeamLines: [],
        headRemark: '',
        fileList: []
      }
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },
  watch: {
    detailsShow (val) {
      this.dialogVisible = val
      val && this.getDetail()
    }
  },
  filters: {
    imgListFormat (list) {
      const imgList = list.map((item) => {
        return item.filePrefix + item.fileUrl
      })
      return imgList || []
    }

  },
  methods: {
    getDetail () {
      this.$axios.get(this.$apis.laborManage.selectYhMachineTeamByMachineTeamId, { machineTeamId: this.id }).then(res => {
        if (res) {
          // res.fileList = []
          res.machineTeamLines.forEach((item) => {
            item.isFirstAllChoose = true
          })
          this.info = res
        }
      })
    },

    getSummaries (param) {
      const { data } = param
      let total = 0
      data.forEach((item) => {
        if (/^([1-9][0-9]*|[0-9])(\.\d)?$/.test(item.teamPrice)) {
          total += parseFloat(item.teamPrice)
        }
      })
      return ['合计', '', '', '', '', '', total, '']
    },

    handleClose () {
      this.$emit('update:detailsShow', false)
      this.$emit('update:id', '')
      this.info = {
        // 基础信息
        projectId: '',
        machineTeamDate: '',
        machineTeamLines: [],
        headRemark: '',
        fileList: []
      }
      this.$refs.formData.resetFields()
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.global-form2 .el-textarea {
  width: 380px;
}

::v-deep .el-dialog {
  // height: 718px !important;
}

::v-deep .el-table__body {

  // .cell{
  //   overflow:visible !important;
  // }
  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-input {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 93%;
    left: 0px;
    z-index: 9999;
    // position: relative;
  }

  .el-table__row {
    height: 62px;
  }
}

.flex {
  display: flex;

  .el-form-item {
    flex: 1 !important
  }
}

.imgList {
  width: 100%;
  min-height: 104px;
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;

  .imgListTitle {
    margin-right: 10px;
  }

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin: 0 10px 10px 0 !important;

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;

    i {
      font-size: 22px;
      color: #999;
      margin-bottom: 7px;
    }
  }

  ::v-deep .el-upload {
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
  }
}
</style>
